module.exports = __webpack_public_path__ + "img/img-10.bc054062.png";